import GetDashboardsClient from 'use-case/dashboards/get/getDashboardsClient';
import { Result } from 'domain/types';
import Dashboard from 'domain/entity/dashboard';
import GetDashboardsCriteria from 'use-case/dashboards/get/getDashboardsCriteria';

export type DashboardsResult = Result<Array<Dashboard>>;
export type GetDashboards = (criteria: GetDashboardsCriteria) => Promise<DashboardsResult>;

export default (getDashboardsClient: GetDashboardsClient): GetDashboards => (criteria: GetDashboardsCriteria): Promise<DashboardsResult> =>
    getDashboardsClient(criteria);
